<template>
  <div id="ProjectEditHandsontable">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">{{number}} {{text}}</span>
        <HandsontableButtonAdd class="handsontable_btn_add" v-if="addButtonVisiable" slot="button" :eventBusEventName="addRowName" />
      </eb-panel-header>
      <div slot="body">
        <ebHandsontableEdit :isAfterRenderer="isAfterRenderer" @removeRowEvent="removeRowEvent" :hotSettings="hotSettings" :addRowName="addRowName" class="panel-handsontable" />
         <div v-if="isTotalShow" class="quoteMin">总计：{{total|formatCurrency}}元</div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import ebHandsontableEdit from '@/components/common/eb-handsontable-edit';
import HandsontableButtonAdd from '@/components/project/common/HandsontableButtonAddRow';
import { isObject } from 'lodash';
export default {
  name: 'ProjectEditHandsontable',
  props: {
    hotSettings: {
      required: true
    },
    addRowName: {
      default: 'projbidNewPurchaselistAddRow'
    },
    title: {},
    addButtonVisiable: {
      default: true
    },
    isAfterRenderer: {
      default: true
    },
    total: {},
    isTotalShow: {
      default: false
    }
  },
  components: {
    ebPanel,
    ebPanelHeader,
    ebHandsontableEdit,
    HandsontableButtonAdd
  },
  data() {
    return {
      number: '',
      text: ''
    };
  },
  watch: {
    title: {
      handler: function(newVal) {
        this.initTitle(newVal);
      },
      deep: true
    }
  },
  created() {
    this.initTitle(this.title);
  },
  methods: {
    removeRowEvent: function(params) {
      this.$emit('removeRowEvent', params);
    },
    initTitle: function(value) {
      if (isObject(value)) {
        if (value['text']) {
          this.text = value['text'];
        }
        if (value['number']) {
          this.number = value['number'];
        }
      } else {
        this.text = value;
      }
    }
  }
};
</script>
<style scoped lang="less">
.panel-handsontable {
  padding-top: 7px;
}
.quoteMin {
  text-align: right;
  padding:10px 10px 0 0;
}
</style>
